import React, { useState } from 'react';
import { supabase } from '../App';
import { Button } from '../components/ui/button';

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const IntroPage = () => {
  const [loading, setLoading] = useState(false);

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/home`
        }
      });

      if (error) {
        console.error('Google login error:', error);
        alert('登录失败: ' + error.message);
        setLoading(false);
      }
    } catch (err) {
      console.error('Error:', err);
      alert('登录失败，请重试');
      setLoading(false);
    }
  };

  const handleXLogin = async () => {
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'twitter',
        options: {
          redirectTo: `${window.location.origin}/home`
        }
      });

      if (error) {
        console.error('X login error:', error);
        alert('登录失败: ' + error.message);
        setLoading(false);
      }
    } catch (err) {
      console.error('Error:', err);
      alert('登录失败，请重试');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-5" style={{
      background: 'linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 100%)'
    }}>
      <div className="text-center max-w-md">
        <img src="/logo.svg" alt="X Painkiller" className="w-20 h-20 mx-auto mb-4" />
        <h1 className="text-5xl font-bold mb-2" style={{
          background: 'linear-gradient(135deg, #6366f1 0%, #ec4899 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          X Painkiller
        </h1>
        <p className="text-lg mb-8" style={{ color: '#9ca3af' }}>
          One dose. Zero pain points.
        </p>

        {/* Google login - commented out
        <Button
          onClick={handleGoogleLogin}
          disabled={loading}
          className="w-full bg-white text-gray-800 hover:bg-gray-50 shadow-lg hover:shadow-xl transition-all duration-200 py-6 text-lg font-semibold rounded-xl gap-3"
        >
          <GoogleIcon />
          {loading ? 'Signing in...' : 'Continue with Google'}
        </Button>
        */}

        <Button
          onClick={handleXLogin}
          disabled={loading}
          className="w-full py-6 text-lg font-semibold rounded-lg gap-3 transition-all duration-200"
          style={{
            background: '#18181b',
            color: '#fafafa',
            border: '1px solid rgba(255,255,255,0.1)'
          }}
        >
          <XIcon />
          {loading ? 'Signing in...' : 'Continue with X'}
        </Button>
      </div>
    </div>
  );
};

export default IntroPage;
